module.exports = __webpack_public_path__ + "img/12.1230eda9.jpg";